define('app/views/templates/helpers/checkClubRenderSection',['Handlebars','underscore'], function ( Handlebars, _ ){
    function checkClubRenderSection(section) {
        var showAccountMemberships = ['member', 'status', 'effectivedate', 'expirydate'];
        var showAccountDetails = ['account', 'accounttype', 'accountowner', 'memberid', 'memberlevel', 'address', 'phone'];

        var tempClubShow = _.map ( Customization.club.show, function(string){
        return string.replace(/ /g, "").trim().toLowerCase();
        });

        if(section == "Account Details"){
           return  _.intersection(tempClubShow, showAccountDetails).length;
        } else if(section == "Member"){
            return  _.intersection(tempClubShow, showAccountMemberships).length;
        } 
    }

    Handlebars.registerHelper( 'checkClubRenderSection', checkClubRenderSection );
    return checkClubRenderSection;
});
